var LOADING_MODE = {
  BLUR: 'BLUR',
  COLOR: 'COLOR'
};
export default LOADING_MODE;